/* `EnrollmentStatusEnum` as the BFF's schema spells it, in place of the
/* `'Y' | 'N' | 'P'` the REST enrollment payload carried. The enum was
/* `MilitaryDiscountEnrollmentStatus` and the field `militaryDiscountStatus`
/* until ACC3-750 renamed both; the members themselves did not change.
/*
/* Only the value this experience branches on is listed. Enrollment itself is
/* read off `isEnrolled`, which is the BFF's own `'Y'` test, and `PENDING` needs
/* no name here - it is simply neither of those. */

/* No enrollment, and no application in flight either. The distinction from
/* PENDING is the whole reason this field is selected alongside the boolean: a
/* customer partway through an application is not sent back to the start of one. */
export const MD_NOT_ENROLLED = 'NOT_ENROLLED';
